"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const UserRegistrationContext_1 = require("@/context/UserRegistrationContext");
const UserRegistration_1 = __importDefault(require("@/components/UserRegistration"));
const code_helpers_1 = require("@emarketer/code-helpers");
const App = ({ placement = 'bottom', baseUrl, loginUrl, registrationSource, subscriptionApiUrl, preferenceApiUrl, analyticsPrefix, freemiumExtranetId, userId, email, lastScreenButtonText = 'Continue Reading', isCaptchaEnabled = false, captchaPublicKey = '', registrationStepCopy, plgThresholdToShowPopup, onEmailSuccessfulEntry, salesforceProxyApiUrl, trialUrl, successContinueUrl, }) => {
    const registrationProps = {
        placement,
        baseUrl,
        loginUrl,
        registrationSource,
        subscriptionApiUrl: (0, code_helpers_1.trimTrailingSlash)(subscriptionApiUrl), // make sure there is no trailing slash
        preferenceApiUrl: (0, code_helpers_1.trimTrailingSlash)(preferenceApiUrl), // make sure there is no trailing slash
        analyticsPrefix: analyticsPrefix?.replace(/^-+|-+$/g, ''), // remove trailing and leading dashes
        freemiumExtranetId,
        userId,
        email,
        lastScreenButtonText,
        isCaptchaEnabled,
        captchaPublicKey,
        registrationStepCopy,
        plgThresholdToShowPopup,
        onEmailSuccessfulEntry,
        salesforceProxyApiUrl: (0, code_helpers_1.trimTrailingSlash)(salesforceProxyApiUrl), // make sure there is no trailing slash
        trialUrl,
        successContinueUrl,
    };
    return (react_1.default.createElement(UserRegistrationContext_1.UserRegistrationProvider, { registrationProps: registrationProps },
        react_1.default.createElement(UserRegistration_1.default, null)));
};
exports.default = App;
